<div class="card-body pt-0 mt-n5">
  <div class="text-center">
    <div class="mt-3">
      <h5>
        {{ userName }}
        @if (isVerified) {
          <i class="bi bi-patch-check-fill align-baseline text-info ms-1"></i>
        }
      </h5>
    </div>
  </div>
</div>
